export default "__VITE_ASSET__BElImXMv__"